<template>
  <section class="cockpit-panel risk-panel">
    <div class="cockpit-title">风险预警</div>
    <div class="risk-content">
      <h4><span></span>轻微水分胁迫</h4>
      <p>干旱风险：中&nbsp;&nbsp;&nbsp;积温偏差：低</p>
      <p>养分不足：低&nbsp;&nbsp;&nbsp;病虫害风险：低</p>
      <p>建议：傍晚补水，雨后巡检</p>
    </div>
  </section>
</template>

<style lang="less" scoped>
@import "./rightPanelShared.less";

.risk-panel {
  padding: 88px 42px 36px;
}

.risk-panel::before {
  top: auto;
  bottom: -1px;
  border-width: 0 0 3px 3px;
}

.risk-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

h4 {
  display: flex;
  align-items: center;
  margin: 0 0 40px;
  color: #7ffff5;
  font-size: 36px;
  // font-weight: 900;
  line-height: 36px;
}

h4 span {
  width: 8px;
  height: 36px;
  margin-right: 22px;
  background: #54fff0;
  box-shadow: 0 0 10px rgba(84, 255, 240, 0.78);
}

p {
  margin: 0 0 14px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 900;
  line-height: 36px;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.25);
}
</style>
